"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { Navbar } from "./Navbar";
import { Button } from "./Button";
import * as _utils from "./utils";
import _styles from "./OnboardingGmailConnected.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-5":{"id":"e-5","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-3","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-6"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"392cc282-3f80-7ffb-8596-2b9f99dae886"},"targets":[],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1725597764523},"e-7":{"id":"e-7","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-3","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-8"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"392cc282-3f80-7ffb-8596-2b9f99dae8a3"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":0,"direction":null,"effectIn":false},"createdOn":1725598449594},"e-9":{"id":"e-9","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-3","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-10"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"392cc282-3f80-7ffb-8596-2b9f99dae8a2"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1725598615997}},"actionLists":{"a-3":{"id":"a-3","title":"scan-inbox-bar","actionItemGroups":[{"actionItems":[{"id":"a-3-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".image-7","selectorGuids":["981344f8-b7e6-7a55-b2fe-aa39a747b9eb"]},"xValue":0,"yValue":0,"zValue":0,"xUnit":"px","yUnit":"px","zUnit":"px"}}]},{"actionItems":[{"id":"a-3-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":900,"target":{"selector":".image-7","selectorGuids":["981344f8-b7e6-7a55-b2fe-aa39a747b9eb"]},"yValue":180,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"actionItems":[{"id":"a-3-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeOut","duration":800,"target":{"selector":".image-7","selectorGuids":["981344f8-b7e6-7a55-b2fe-aa39a747b9eb"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1725423771699}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function OnboardingGmailConnected({
  as: _Component = _Builtin.Block,
  profileImageUrl = "https://cdn.prod.website-files.com/66d787122d570263af824e4d/66d795c1a0d798f75d26417a_default-pfp.png",
  emailText = "johndoe@gmail.com",
  addedOnText = "added on Aug 26th, 2024",

  tryAnotherEmailLink = {
    href: "#",
  },

  tryAnotherEmailProps = {},
  continueProps = {},
  backBtnProps = {},
  animationSlot,
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(
        _styles,
        "flex-grow-container",
        "main-section",
        "with-back-btn",
        "fixed-full-screen"
      )}
      data-w-id="392cc282-3f80-7ffb-8596-2b9f99dae886"
      tag="div"
    >
      <Navbar backBtnProps={backBtnProps} />
      <_Builtin.Block className={_utils.cx(_styles, "div-block-46")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "connected-to-your-gmail")}
          tag="div"
          data-figma-id="154:447"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "frame-33")}
            tag="div"
            data-figma-id="105:174"
          >
            <_Builtin.Paragraph
              className={_utils.cx(_styles, "connected-to-your-gmail-2")}
              data-figma-id="18:102"
            >
              {"Connected to your Gmail"}
            </_Builtin.Paragraph>
            <_Builtin.Block
              className={_utils.cx(_styles, "frame-30")}
              tag="div"
              data-figma-id="105:173"
            >
              <_Builtin.Paragraph
                className={_utils.cx(
                  _styles,
                  "error-b3f347e7-5651-bf1f-23ae-66c4b4596736"
                )}
                data-figma-id="18:103"
              >
                {
                  "Newsletter detection underway...Get ready to finally get the most out of the content you've subscribed to."
                }
              </_Builtin.Paragraph>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-45")}
                tag="div"
                data-figma-id="105:172"
              >
                <_Builtin.Image
                  width="auto"
                  height="auto"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/66d787122d570263af824e4d/66d789a348acbce12bed46dd_Abstract%20Diamond.png"
                />
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "error-ce9d8e33-a018-2cb5-9ff2-82fdddede122"
                  )}
                  data-figma-id="97:774"
                >
                  {"We’re detecting newsletter you are subscribed to."}
                </_Builtin.Paragraph>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "frame-32")}
            tag="div"
            data-figma-id="105:176"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "cta")}
              tag="div"
              data-figma-id="18:104"
            >
              <_Builtin.Image
                width="auto"
                height="auto"
                loading="lazy"
                alt=""
                src="https://cdn.prod.website-files.com/66d787122d570263af824e4d/66d789a348acbce12bed46a9_Check_fill.png"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "frame-18")}
                tag="div"
                data-figma-id="27:22"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-5")}
                  loading="auto"
                  width="42"
                  height="Auto"
                  alt=""
                  src={profileImageUrl}
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "frame-16")}
                  tag="div"
                  data-figma-id="22:16"
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "johndoe-gmail-com")}
                    data-figma-id="18:107"
                  >
                    {emailText}
                  </_Builtin.Paragraph>
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "added-on-aug-26th-2024")}
                    data-figma-id="22:15"
                  >
                    {addedOnText}
                  </_Builtin.Paragraph>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block tag="div" data-figma-id="101:779">
              <_Builtin.Link
                className={_utils.cx(_styles, "try-another-email")}
                button={false}
                data-figma-id="22:12"
                block=""
                options={tryAnotherEmailLink}
                {...tryAnotherEmailProps}
              >
                {"Try another email"}
              </_Builtin.Link>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "div-block-41")}
          tag="div"
          data-figma-id="56:256"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "div-block-44")}
            data-w-id="392cc282-3f80-7ffb-8596-2b9f99dae8a2"
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "publisher-animation")}
              tag="div"
            >
              {animationSlot ?? (
                <>
                  <_Builtin.Image
                    className={_utils.cx(_styles, "scanning-inbox")}
                    data-w-id="392cc282-3f80-7ffb-8596-2b9f99dae8a3"
                    width="Auto"
                    height="auto"
                    loading="lazy"
                    alt=""
                    src="https://cdn.prod.website-files.com/66d787122d570263af824e4d/66d7dff93ae1f8b565025277_gmail-inbox.png"
                  />
                  <_Builtin.Image
                    className={_utils.cx(_styles, "image-7")}
                    loading="lazy"
                    width="auto"
                    height="auto"
                    alt=""
                    src="https://cdn.prod.website-files.com/66d787122d570263af824e4d/66d7dff6ca5c3c0fe3e26f6f_inbox-scan-bar.png"
                  />
                </>
              )}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, "div-block-49")} tag="div">
        <Button props={continueProps} />
      </_Builtin.Block>
    </_Component>
  );
}
